import { PureComponent } from 'react';
import invariant from 'react-utils/invariant';
import PropTypes from 'prop-types';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import getPDFPageState from '../../selectors/getPDFPageState';
import PDFPageImage from './PDFPageImage';
import { jsx as _jsx } from "react/jsx-runtime";
export default class PDFPage extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      pageObject: null,
      viewport: null,
      prevPageIndex: this.props.pageIndex,
      prevPdf: this.props.pdf,
      prevZoom: this.props.zoom
    };
    this.buildPageObject = () => {
      const {
        pdf
      } = this.props;
      const {
        pageNumber
      } = getPDFPageState(this.props);
      pdf.getPage(pageNumber).then(pageObject => {
        this.setState({
          pageObject
        });
      }).catch(err => console.error(err));
    };
    this.buildViewport = () => {
      const {
        zoom
      } = this.props;
      const {
        pageObject
      } = this.state;
      invariant(pageObject !== null, 'PDFPage: buildViewport is being called too early. pageObject is null while trying to build viewport');
      const containerWidth = this.page.offsetWidth;
      const containerHeight = this.page.offsetHeight;
      const originalSizeViewport = pageObject.getViewport({
        scale: 1
      });
      const originalSizeWidth = originalSizeViewport.width;
      const originalSizeHeight = originalSizeViewport.height;
      const xScale = containerWidth / originalSizeWidth;
      const yScale = containerHeight / originalSizeHeight;
      const isOriginalScreenHeightLargerThanContainerHeight = xScale * originalSizeHeight > containerHeight;
      const baseScale = isOriginalScreenHeightLargerThanContainerHeight ? yScale : xScale;
      const adjustedViewport = pageObject.getViewport({
        /**
         * // multiply by .75 because current pdfJS set css variable
         * // --scale-factor to scale * PixelsPerInch.PDF_TO_CSS_UNITS
         * // PixelsPerInch.PDF_TO_CSS_UNITS is hard coded in their source
         * // (96 / 72 = 1.3333333333333333)
         */
        scale: baseScale * zoom * 0.75
      });
      this.setState({
        viewport: adjustedViewport
      });
    };
    this.renderPageContents = () => {
      const {
        pageIndex
      } = this.props;
      const {
        pageObject,
        viewport
      } = this.state;
      if (viewport === null) {
        return null;
      }
      return /*#__PURE__*/_jsx(PDFPageImage, {
        pageObject: pageObject,
        viewport: viewport,
        pageIndex: pageIndex
      });
    };
  }
  static getDerivedStateFromProps(props, state) {
    let shouldUpdateState = false;
    const stateUpdate = {};
    const {
      pageIndex,
      pdf,
      zoom
    } = props;
    if (pageIndex !== state.prevPageIndex || pdf !== state.prevPdf) {
      stateUpdate.prevPageIndex = pageIndex;
      stateUpdate.prevPdf = pdf;
      stateUpdate.pageObject = null;
      stateUpdate.viewport = null;
      shouldUpdateState = true;
    }
    if (zoom !== state.prevZoom) {
      stateUpdate.prevZoom = zoom;
      stateUpdate.viewport = null;
      shouldUpdateState = true;
    }
    return shouldUpdateState ? stateUpdate : null;
  }
  componentDidMount() {
    this.buildPageObject();
    window.addEventListener('resize', this.buildViewport);
  }
  componentDidUpdate() {
    const {
      pageObject,
      viewport
    } = this.state;
    if (pageObject === null) {
      this.buildPageObject();
      return;
    }
    if (viewport === null) {
      this.buildViewport();
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.buildViewport);
  }
  render() {
    const {
      pageObject
    } = this.state;
    if (pageObject === null) {
      return null;
    }
    return /*#__PURE__*/_jsx(TFlex, {
      ref: c => {
        this.page = c;
      },
      children: this.renderPageContents()
    });
  }
}
PDFPage.propTypes = {
  pdf: PropTypes.object.isRequired,
  pageIndex: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired
};